import {
  ChangeDetectionStrategy,
  Component,
  effect,
  ElementRef,
  input,
  InputSignal,
  Signal,
  signal,
  viewChild,
  WritableSignal
} from '@angular/core';
import { GameCardV2Component, RedirectTypeEnum } from '@ui-components';
import { GameDetailsModel } from '@core';

@Component({
  selector: 'lib-last-games-carousel',
  templateUrl: './last-games-carousel.component.html',
  styleUrls: ['./last-games-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [GameCardV2Component]
})
export class LastGamesCarouselComponent {
  readonly games: InputSignal<GameDetailsModel[]> = input.required<GameDetailsModel[]>();

  readonly redirectType: RedirectTypeEnum = RedirectTypeEnum.GAME;

  readonly carouselRef: Signal<ElementRef<HTMLDivElement> | undefined> =
    viewChild<ElementRef<HTMLDivElement>>('carouselRef');
  readonly canScrollLeft: WritableSignal<boolean> = signal<boolean>(false);
  readonly canScrollRight: WritableSignal<boolean> = signal<boolean>(false);

  constructor() {
    effect(() => {
      const ref: ElementRef<HTMLDivElement> | undefined = this.carouselRef();
      const games: GameDetailsModel[] = this.games();
      if (ref && games.length > 0) queueMicrotask(() => this.onCarouselScroll());
    });
  }

  onCarouselScroll(): void {
    const el: HTMLDivElement | undefined = this.carouselRef()?.nativeElement;
    if (!el) return;
    this.canScrollLeft.set(el.scrollLeft > 0);
    this.canScrollRight.set(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  }

  scrollPrev(): void {
    const el: HTMLDivElement | undefined = this.carouselRef()?.nativeElement;
    if (!el) return;
    el.scrollBy({ left: -el.clientWidth, behavior: 'smooth' });
  }

  scrollNext(): void {
    const el: HTMLDivElement | undefined = this.carouselRef()?.nativeElement;
    if (!el) return;
    el.scrollBy({ left: el.clientWidth, behavior: 'smooth' });
  }
}
